import styled from "styled-components";
import color from "../assets/colors";


export const ButtonLogin = styled.button`

margin-left: auto;
margin-right: auto;
display: block;
margin-top: 68px;
width: 375px;
font-size: 17px;
border: 1px solid ${props => props.color || color.colorBtn};
padding: 8px 12px;
background-color: ${props => props.color || color.primary};


`;



